import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'function',
  version: '1.0.0',
  properties: [
    {
      key: 'mode',
      label: 'Run Mode',
      type: 'options',
      required: true,
      default: 'runOnceForAllItems',
      options: [
        {
          value: 'runOnceForAllItems',
          name: 'Run Once for All Items',
          description: 'Execute code once with all items available in the items array',
        },
        {
          value: 'runOnceForEachItem',
          name: 'Run Once for Each Item',
          description: 'Execute code for each input item separately',
        },
      ],
      description: 'Choose whether to execute code once with all items, or once per input item',
    },
    {
      key: 'code',
      label: 'JavaScript Code',
      type: 'code',
      required: true,
      default: `// Available variables:
// - items: Array of all input items
// - $input: Input data from previous node
// - $node: Access previous node outputs
// - $vars: Workflow variables

// Transform the data and return
return items.map(item => ({
  ...item,
  processed: true
}));`,
      typeOptions: {
        language: 'javascript',
        rows: 15,
      },
      description: 'JavaScript code to execute. Must return the result.',
    },
    {
      key: 'language',
      label: 'Language',
      type: 'hidden',
      default: 'javascript',
    },
    {
      key: 'executionTier',
      label: 'Execution Tier',
      type: 'options',
      default: 'sandboxed',
      options: [
        {
          value: 'sandboxed',
          name: 'Sandboxed (5s timeout)',
          description: 'Safe execution with 5 second timeout and limited resources',
        },
        {
          value: 'extended',
          name: 'Extended (30s timeout)',
          description: 'Longer execution time with more resources',
        },
      ],
      description: 'Extended tier allows longer execution and more resources',
      section: 'settings',
    },
  ],
};

export default schema;
